<template>
  <section class="section section--skills" id="skills">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 10"
      preserveAspectRatio="none"
    >
      <polygon points="100 10 0 0 0 10" />
    </svg>

    <div class="section__inner">
      <div class="block">
        <a class="pre" href="#skills"> <span>#3</span>Skills </a>
        <div class="section__inner--column">
          <h2>
            Snowie is mostly working on
            <br />Front-end and sometimes <br />full stack.
          </h2>
          <div class="lead">
            Her tech stack includes but not limit to:
            <ul>
              <li v-for="lang in languages">{ {{ lang }} }</li>
            </ul>
          </div>
        </div>

        <p class="lead">Here are some of her recent works:</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Skills",
  data() {
    return {
      languages: [
        "HTML5",
        "CSS: Sass, Less",
        "JavaScript: jQuery, React, Vue, Node, ..",
        "CMS: Wordpress, Shopify, Drupal, .."
      ]
    };
  }
};
</script>

<style lang="scss">
.section--skills.section {
  background-color: $theme4;
  color: white;
  .section__inner {
    max-width: 900px;
    .section__inner--column {
      display: flex;
      @media (max-width: 650px) {
        flex-wrap: wrap;
      }
      .lead {
        @media (max-width: 650px) {
          padding: 10px 0;
          font-size: 0.875rem;
        }
        padding-left: 5%;
        padding-top: 15%;
        font-size: 0.7rem;
        height: 50%;
        line-height: 1.2;
        ul {
          margin-top: 0.5rem;
          li {
            font-family: "Courier New";
            font-weight: bold;
            list-style-type: none;
          }
        }
      }
    }
  }

  svg {
    fill: $theme4;
    top: -20px;
  }
}
</style>
